import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyClubsState } from '../reducers/index';

export const getDragonflyClubs = createSelector(getDragonflyClubsState, (state) => state.search);

export const getPanelExpanded = createSelector(
  getDragonflyClubs,
  ({ panelExpanded }) => panelExpanded,
);

export const getClubName = createSelector(getDragonflyClubs, ({ clubName }) => clubName);

export const getClubCode = createSelector(getDragonflyClubs, ({ clubCode }) => clubCode);

export const getStartDate = createSelector(getDragonflyClubs, ({ clubStartDate }) => clubStartDate);

export const getStartDateFormat = createSelector(
  getDragonflyClubs,
  ({ clubStartDateFormat }) => clubStartDateFormat,
);

export const getClubEndDate = createSelector(getDragonflyClubs, ({ clubEndDate }) => clubEndDate);

export const getClubEndDateFormat = createSelector(
  getDragonflyClubs,
  ({ clubEndDateFormat }) => clubEndDateFormat,
);

export const getClubStartDateValidation = createSelector(getDragonflyClubs, ({ clubStartDate }) =>
  clubStartDate?.toISOString() !== new Date(0).toISOString() ? clubStartDate : '',
);

export const getClubEndDateLTStartDate = createSelector(
  getStartDate,
  getClubEndDate,
  getStartDateFormat,
  getClubEndDateFormat,
  (clubStartDate, clubEndDate, clubStartDateFormat, clubEndDateFormat) =>
    clubStartDateFormat && clubEndDateFormat ? clubStartDate > clubEndDate : false,
);

export const getClubEndDateValidation = createSelector(getDragonflyClubs, ({ clubEndDate }) =>
  clubEndDate?.toISOString() !== new Date(0).toISOString() ? clubEndDate : '',
);

export const getShowInactiveClubs = createSelector(
  getDragonflyClubs,
  ({ showInactiveClubs }) => showInactiveClubs,
);

export const getHasNotClubSearchRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('clubs.search') ? false : true,
);

export const getClubDisableSearch = createSelector(
  getHasNotClubSearchRole,
  getClubEndDateLTStartDate,
  (noSearchRole, clubEndDateLTStartDate) => noSearchRole || clubEndDateLTStartDate,
);
